/* global Blockly */
import React from 'react'


function defineBlock(context) {
    return {
        init: function() {
            let selectChartDropdown = new Blockly.FieldWidgetsDropdown(context, 'chart', undefined, '- select -');

            this.appendDummyInput('WIDGET')
                .appendField("refresh chart")
                .appendField(selectChartDropdown, "ID");
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setOutput(false);
            this.setPreviousStatement(true);
            this.setNextStatement(true);
            this.setTooltip("Refresh the selected chart.");
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#charts')
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let id = block.getFieldValue('ID');
            let code = `Snap.widgets.chart.refresh("${id}");\n`;
            return code;
        }
    }
}

const RefreshChart = function (props) {
    let name = "snap_refresh_chart";
    RefreshChart.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators(props.context);
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (props.widgets.length < 1) {
        return null;
    }

    return <block type={name}>
                {props.widget && (props.widget.id !== undefined) ?
                    <field name='ID'>{props.widget.id}</field>
                    : null
                }
            </block>;
}

export default RefreshChart;